import React from "react";
import CustomerServicePage from "../Components/CustomerService/CustomerServicePage";

const CustomerService = () => {
  return <CustomerServicePage />;
};

export default CustomerService;